<template lang="pug">
  .progress-bar
    //svg.bg.bar(:width="bgWidth" :height="bgHeight" viewBox="0 0 375 10" fill="none" xmlns="http://www.w3.org/2000/svg")
      g
        path(d="M376.5 1.8C375.3 1.6 373.1 1.5 371.1 1.5C372.6 1.7 374.3 1.8 376.5 1.8Z" fill="#CBCBCB")
        path(d="M371 1.40002C371 1.50002 371.1 1.50002 371 1.40002C371.1 1.40002 371.1 1.40002 371 1.40002Z" fill="#CBCBCB")
        path(d="M273.5 0.4L273.2 0.8C268.4 0.8 271.8 0.3 267.4 0.4C265.7 1 260.1 0.3 258.5 0.6C258.5 0.6 256.4 0.5 256.5 0.4C255.8 0.7 254.3 0.5 252.9 0.5C252.4 0.6 253.3 0.6 253.6 0.7L250.5 0.8C249.3 0.7 249 0.5 250.3 0.5C242.1 0.4 202.9 -0.1 194.1 0.1C195.2 0.3 197.9 0.2 199 0.6C196.7 0.8 195.6 0.5 194.6 0.7C193.7 0.2 189.5 0.6 187.7 0L187 0.3L185.8 0.1C175.6 0.4 183.5 0.2 174.4 0.1C169.2 0.1 166.7 0.5 163.7 0.4C164.1 0.4 165.3 0.6 163.9 0.7C163.7 0.4 160.3 0.9 159.6 0.6C158.3 0.6 154 0.6 155.4 1C154.7 0.8 150.8 0.7 153.1 0.6C151.8 0.6 150.5 0.5 149.6 0.6L151.3 0.7C146.9 0.7 144.5 0.4 141.7 0.8L143.3 1C140.7 1 138.5 1 137.5 0.7L140.2 0.6C135.9 0.6 133.2 0.6 129.6 0.8H130.9C126.3 1.1 102.1 1.4 97.9 1.8L99.9 2.1L96.3 2.2C96.7 2.2 98.1 1.3 98.4 1.4C90.6 1.4 49.8 1.5 42.5 1.3C39.6 1.1 42 0.8 42 0.8C38.6 0.8 40.6 1 37.6 1C36.8 0.9 37.8 0.8 38.2 0.7C36.9 0.7 35.6 0.6 35.5 0.8C37.2 0.9 36.5 1.3 37.2 1.5H33.3L33.5 1.3C32.6 1.3 31.3 1.9 27.5 1.8C21.1 1.7 14.1 1.7 7.6 1.7C7.7 1.6 9.1 1.5 10.4 1.4C9.5 1.4 8.2 1.4 7.4 1.3C9 1.5 4.7 1.4 5.9 1.6C1.2 2.1 -5 1.6 -9.2 2C-9.4 2.2 -11.6 4.3 -13.8 6.4C-14.3 6.9 -14.9 7.4 -15.4 8C-15.8 8.5 -16.2 9 -16.4 9.5C-16.9 10.4 -16.9 11 -16.8 11.2C-16.9 11.2 -16.9 11.2 -16.9 11.2V11.1C-17 10.9 -17.1 10.7 -17.2 10.4C-17.4 9.7 -17.6 9.4 -17.8 9.1C-17.9 8.8 -18.2 8.5 -18.3 8.4C-18.3 8.3 -18.4 8.2 -18.5 8.1L-18.6 8C-18.6 8 -18.7 7.9 -18.8 7.9C-18.8 7.9 -18.8 7.9 -18.9 7.8H-19C-19 7.8 -19 7.8 -18.9 7.9C-18.5 8 -18.1 8.5 -17.6 9.4C-17.5 9.7 -17.4 9.9 -17.2 10.2C-17.1 10.4 -17.1 10.5 -17 10.7C-16.9 10.8 -16.9 11.1 -16.9 11C-16.9 11 -16.9 11 -16.8 11C-16.6 11 -16.4 10.9 -16.3 10.9L-16.2 10.6C-15.2 10.5 -15 10.6 -14.8 10.6C-14.6 10.7 -14.5 10.7 -12.9 10.7C-12.8 10.8 -13.5 10.9 -14.5 10.9C-15.1 10.9 -15.4 10.9 -15.8 11C-16.2 11 -16.6 11.1 -16.8 11.1C-16.6 11.1 -16.3 11 -16 11C-15.6 11 -15.3 11 -14.9 11C-14 11 -13.2 11 -12.7 10.9C-10.6 11 -12.9 11.2 -10.4 11.3C-8.6 11.2 -6.2 11 -4.2 11.1C0.799999 11.4 3.5 10.7 8.1 11L7.6 11.1C9.2 11.3 12.4 11.1 15.3 11.2C14.5 11.1 13.7 11 15.5 10.9C18.9 11.1 21.1 10.9 23.6 11.1L26 10.9C37.7 11 83.9 10.8 95.6 10.8H95.1C113 10.7 149.7 10.9 168.2 10.6C171.1 10.9 175 10.8 178 10.9C176.3 10.8 176.9 10.6 178.2 10.6C187.3 10.7 178.8 10.4 188 10.4C198.6 10.2 239.1 10.6 248.5 10.8C253.6 10.5 259.9 10.7 264.8 10.5L264.3 10.6C269.6 10.5 299.7 10.9 305.9 10.8L305.1 10.7C310.5 10.5 309.8 10.9 314 11C313.4 10.6 318.1 10.4 319.8 10.4L319.7 10.5C322.4 10.4 328.4 10.1 332.7 10.1L332.5 10.3C336.2 10.1 343 10.2 345.7 10.2C351.7 10.3 361 10.7 369 10.5L374.2 11.1L375 11C375 11 383.4 3.4 372.8 1.7L373 1.5H370.9C368.4 1.4 367.2 1.6 367.4 1.4H370.8C368.3 1.3 370 1.2 371 1.1C369.9 1.1 368.9 1 368.1 1C367.6 1.1 368.5 1.1 368.9 1.1C367.5 1.2 365.6 1.4 364 1.3C361.4 1.3 363.8 0.9 360.8 0.9C344.8 1 329.4 0.7 313.3 0.7C312.9 0.6 313.4 0.6 313.8 0.6C308.9 0.6 304.6 0.7 300.2 0.7C299 0.6 298.6 0.5 298.3 0.4C298.7 0.5 292.6 0.5 286.3 0.5C283.2 0.5 280 0.5 277.6 0.5C275.3 0.5 273.6 0.5 273.5 0.4Z" fill="#CBCBCB")
    svg.fg.bar(:width="bgWidth" :height="bgHeight" viewBox="0 0 375 10" fill="none" xmlns="http://www.w3.org/2000/svg")
      g(clip-path="url(#clip)")
        path(d="M0 10h375V2.2l-2.2-.5.2-.2h-2c-2.6-.1-3.8.1-3.6-.1h3.4c-2.5-.1-.8-.2.2-.3l-2.9-.1c-.5.1.4.1.8.1a38.5 38.5 0 0 1-4.9.2c-2.6 0-.2-.4-3.2-.4-16 .1-31.4-.2-47.5-.2-.4-.1.1-.1.5-.1l-13.6.1a7.8 7.8 0 0 1-1.9-.3c.4.1-5.7.1-12 .1h-8.7a30.6 30.6 0 0 1-4-.1l-.4.4c-4.8 0-1.4-.5-5.8-.4-1.7.6-7.3-.1-8.9.2a12.3 12.3 0 0 1-2-.2c-.7.3-2.2.1-3.6.1-.5.1.4.1.7.2l-3 .1c-1.3-.1-1.6-.3-.3-.3-8.2-.1-47.4-.6-56.2-.4 1.1.2 3.8.1 5 .5-2.4.2-3.5-.1-4.5.1-.9-.5-5-.1-6.9-.7l-.7.3-1.2-.2c-10.2.3-2.3.1-11.4 0-5.2 0-7.7.4-10.7.3.4 0 1.6.2.2.3-.2-.3-3.6.2-4.3-.1-1.3 0-5.6 0-4.2.4-.7-.2-4.6-.3-2.3-.4h-3.5l1.7.1c-4.4 0-6.8-.3-9.6.1l1.6.2a28.3 28.3 0 0 1-5.8-.3l2.7-.1c-4.3 0-7 0-10.6.2h1.3c-4.6.3-28.8.6-33 1l2 .3-3.6.1c.4 0 1.8-.9 2.1-.8-7.8 0-48.6.1-55.9-.1-2.9-.2-.5-.5-.5-.5-3.4 0-1.4.2-4.4.2-.8-.1.2-.2.6-.3-1.3 0-2.6-.1-2.7.1 1.7.1 1 .5 1.7.7h-3.9l.2-.2a31 31 0 0 1-6 .5L7.6 1.7a18.6 18.6 0 0 1 2.8-.3 29 29 0 0 1-3-.1c1.6.2-2.7.1-1.5.3a58.6 58.6 0 0 1-5.9.2" fill="#fff")
      path(:transform="`translate(${progress* 375-1} 0)`" d="M0 9.8s3.4 1.4 4.4 0C6.3 7 7.7 2.7 0 1.5z" fill="#fff")
      defs
        clipPath(id="clip")
          rect(:width="progress*375" :height="bgHeight")

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
export default {
  name: 'progress-bar',
  props: {
    progress: {
      required: true,
      default: 0,
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {

    bgHeight() {
      let ratio =  10/375
      return this.bgWidth * ratio
    },
    bgWidth() {
      return this.windowWidth
      // let img = document.querySelector('#hub-bg')
      // let ratio = img.naturalWidth / img.naturalHeight

    },
    posy(){
      return (this.bgHeight - this.windowHeight)/2.0
    },
    ...mapState('app', ['seenIntro']),
    ...mapState('browser', ['windowWidth', 'windowHeight']),
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    update() {},
  },
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"


.progress-bar
  position: absolute
  width: 100%
  bottom: 0.1rem
  .fg
    g
      fill: white
  svg
    position: absolute
    top: 0
    left: 0
    width: 100%




</style>
